import { render } from "./ArrowMore.vue?vue&type=template&id=60e4aae0&scoped=true"
const script = {}

import "./ArrowMore.vue?vue&type=style&index=0&id=60e4aae0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e4aae0"],['__file',"src/icons/ArrowMore.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60e4aae0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60e4aae0', __exports__)) {
    api.reload('60e4aae0', __exports__)
  }
  
  module.hot.accept("./ArrowMore.vue?vue&type=template&id=60e4aae0&scoped=true", () => {
    api.rerender('60e4aae0', render)
  })

}


export default __exports__